import { createReducer, on } from '@ngrx/store';
import * as Actions from './global.actions';

export const globalReducer = createReducer(
  {
    vatCountries: null,
  },

  /** Load Global settings */
  on(Actions.LoadGlobalConstSuccess, (state, { data }) => ({
    ...state,
    ...data,
  })),
);
